import defaults from '@/modules/default'

const language = defaults.language

export default {
  state: {
    headers: {
      home: {
        recent_orders: [
          {
            text: language.orders.datatable.headers.id,
            value: 'id',
            sortable: true,
            width: '15%'
          },
          {
            text: language.orders.datatable.headers.datetime,
            value: 'datetime',
            sortable: true,
            width: '5%'
          },
          {
            text: language.orders.datatable.headers.customer,
            value: 'customer',
            sortable: true,
            width: '33%'
          },
          {
            text: language.orders.datatable.headers.total,
            value: 'total',
            sortable: true,
            filterable: true,
            width: '15%'
          },
          {
            text: language.orders.datatable.headers.status,
            value: 'status',
            width: '25%',
            sortable: true,
            filterable: true
          },
          {
            text: language.orders.datatable.headers.action,
            value: 'action',
            sortable: false,
            filterable: false,
            width: '7%'
          }
        ],
        scheduler: [
          {
            text: language.scheduler.datatable.headers.customer,
            value: 'customer',
            sortable: true,
            width: '15%'
          },
          {
            text: language.scheduler.datatable.headers.employees,
            value: 'employees',
            sortable: true,
            width: '17%'
          },
          {
            text: language.scheduler.datatable.headers.title,
            value: 'title',
            sortable: true,
            filterable: true,
            width: '20%'
          },
          {
            text: language.scheduler.datatable.headers.scheduling,
            value: 'scheduling',
            width: '25%',
            sortable: true,
            filterable: true
          },
          {
            text: language.scheduler.datatable.headers.status,
            value: 'status',
            width: '13%',
            sortable: true,
            filterable: true
          },
          {
            text: language.scheduler.datatable.headers.action,
            value: 'action',
            sortable: false,
            filterable: false,
            width: '15%'
          }
        ]
      },
      scheduler: [
        {
          text: language.scheduler.datatable.headers.id,
          value: 'id',
          sortable: true,
          width: '5%'
        },
        {
          text: language.scheduler.datatable.headers.created,
          value: 'created',
          sortable: true,
          width: '5%'
        },
        {
          text: language.scheduler.datatable.headers.customer,
          value: 'customer',
          sortable: true,
          width: '20%'
        },
        {
          text: language.scheduler.datatable.headers.employees,
          value: 'employees',
          sortable: true,
          width: '13%'
        },
        {
          text: language.scheduler.datatable.headers.title,
          value: 'title',
          sortable: true,
          filterable: true,
          width: '17%'
        },
        {
          text: language.scheduler.datatable.headers.scheduling,
          value: 'scheduling',
          width: '13%',
          sortable: true,
          filterable: true
        },
        {
          text: language.scheduler.datatable.headers.status,
          value: 'status',
          width: '13%',
          sortable: true,
          filterable: true
        },
        {
          text: language.scheduler.datatable.headers.action,
          value: 'action',
          sortable: false,
          filterable: false,
          width: '10%'
        }
      ],
      orders: [
        {
          text: language.orders.datatable.headers.id,
          value: 'id',
          sortable: true,
          width: '7%'
        },
        {
          text: language.orders.datatable.headers.datetime,
          value: 'datetime',
          sortable: true,
          width: '10%'
        },
        {
          text: language.orders.datatable.headers.customer,
          value: 'customer',
          sortable: true,
          width: '25%'
        },
        /* {
          text: language.orders.datatable.headers.type,
          value: 'type',
          sortable: true,
          filterable: true,
          width: '9%'
        }, */
        {
          text: language.orders.datatable.headers.status,
          value: 'status',
          width: '19%',
          sortable: true,
          filterable: true
        },
        {
          text: language.orders.datatable.headers.paid,
          value: 'paid',
          width: '13%',
          sortable: true,
          filterable: true
        },
        {
          text: language.orders.datatable.headers.total,
          value: 'total',
          sortable: true,
          filterable: true,
          width: '9%'
        },
        {
          text: language.orders.datatable.headers.action,
          value: 'action',
          sortable: false,
          filterable: false,
          width: '14%'
        }
      ],
      services: [
        {
          text: language.services.datatable.headers.id,
          align: 'left',
          sortable: true,
          value: 'id',
          width: '7%'
        },
        {
          text: language.services.datatable.headers.code,
          align: 'left',
          sortable: true,
          value: 'code',
          width: '7%'
        },
        {
          text: language.services.datatable.headers.created,
          value: 'created',
          width: '10%'
        },
        {
          text: language.services.datatable.headers.category,
          value: 'category',
          width: '15%'
        },
        {
          text: language.services.datatable.headers.title,
          value: 'title',
          width: '35%'
        },
        /* {
          text: language.services.datatable.headers.description,
          value: 'description',
          filterable: false
        }, */
        {
          text: language.services.datatable.headers.price,
          value: 'price',
          filterable: false,
          width: '10%'
        },
        {
          text: language.services.datatable.headers.action,
          value: 'action',
          sortable: false,
          filterable: false,
          width: '20%'
        }
      ],
      items: [
        {
          text: language.items.datatable.headers.id,
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: language.items.datatable.headers.thumb,
          align: 'left',
          sortable: false,
          value: 'thumb'
        },
        {
          text: language.items.datatable.headers.code,
          align: 'left',
          sortable: true,
          value: 'code'
        },
        { text: language.items.datatable.headers.created, value: 'created' },
        { text: language.items.datatable.headers.subcategory, value: 'subcategory' },
        { text: language.items.datatable.headers.title, value: 'title' },
        /* { text: language.items.datatable.headers.description, value: 'description', filterable: false }, */
        { text: language.items.datatable.headers.stock_, value: 'stock', filterable: true },
        { text: language.items.datatable.headers.price, value: 'price', filterable: false },
        { text: language.items.datatable.headers.action, value: 'action', sortable: false, filterable: false }
      ],
      additional: [
        {
          text: language.additional.datatable.headers.id,
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: language.additional.datatable.headers.code,
          align: 'left',
          sortable: true,
          value: 'code'
        },
        { text: language.additional.datatable.headers.category, value: 'category' },
        { text: language.additional.datatable.headers.title, value: 'title' },
        { text: language.additional.datatable.headers.description, value: 'description', filterable: false },
        { text: language.additional.datatable.headers.price, value: 'price', filterable: false },
        { text: language.additional.datatable.headers.action, value: 'action', sortable: false, filterable: false }
      ],
      customers: [
        {
          text: language.customers.datatable.headers.id,
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: language.customers.datatable.headers.name,
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: language.customers.datatable.headers.phone,
          align: 'left',
          sortable: true,
          value: 'phone'
        },
        {
          text: language.customers.datatable.headers.identity,
          align: 'left',
          sortable: true,
          value: 'identity'
        },
        {
          text: language.customers.datatable.headers.birth_date,
          align: 'left',
          sortable: true,
          value: 'birth_date'
        },
        {
          text: language.customers.datatable.headers.address,
          align: 'left',
          sortable: true,
          value: 'address'
        },
        {
          text: language.customers.datatable.headers.action,
          align: 'left',
          sortable: false,
          value: 'action',
          filterable: false
        }
      ],
      birthdays: [
        {
          text: language.customers.datatable.headers.id,
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: language.customers.datatable.headers.name,
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: language.customers.datatable.headers.phone,
          align: 'left',
          sortable: true,
          value: 'phone'
        },
        {
          text: language.customers.datatable.headers.action,
          align: 'left',
          sortable: false,
          value: 'action',
          filterable: false
        }
      ],
      historic: {
        orders: [
          {
            text: language.orders.datatable.headers.id,
            value: 'id',
            sortable: true,
            width: '7%'
          },
          {
            text: language.orders.datatable.headers.datetime,
            value: 'datetime',
            sortable: true,
            width: '5%'
          },
          {
            text: language.orders.datatable.headers.customer,
            value: 'customer',
            sortable: true,
            width: '30%'
          },
          {
            text: language.orders.datatable.headers.status,
            value: 'status',
            width: '19%',
            sortable: true,
            filterable: true
          },
          {
            text: language.orders.datatable.headers.total,
            value: 'total',
            sortable: true,
            filterable: true,
            width: '9%'
          },
          {
            text: language.orders.datatable.headers.action,
            value: 'action',
            sortable: false,
            filterable: false,
            width: '14%'
          }
        ]
      },
      financial: {
        overview_periodicals: [
          [
            {
              text: language.financial.periodicals.datatable.headers.next_due,
              align: 'left',
              sortable: true,
              value: 'due',
              width: '20%'
            },
            {
              text: language.financial.periodicals.datatable.headers.title,
              align: 'left',
              sortable: true,
              value: 'title',
              width: '40%'
            },
            {
              text: language.financial.periodicals.datatable.headers.value,
              align: 'left',
              sortable: true,
              value: 'value',
              width: '30%'
            },
            {
              text: language.financial.periodicals.datatable.headers.actions,
              align: 'left',
              sortable: false,
              value: 'actions',
              filterable: false,
              width: '10%'
            }
          ],
          [
            {
              text: language.financial.periodicals.datatable.headers.next_due,
              align: 'left',
              sortable: true,
              value: 'due',
              width: '20%'
            },
            {
              text: language.financial.periodicals.datatable.headers.employee,
              align: 'left',
              sortable: true,
              value: 'employee',
              width: '10%'
            },
            {
              text: language.financial.periodicals.datatable.headers.title,
              align: 'left',
              sortable: true,
              value: 'title',
              width: '35%'
            },
            {
              text: language.financial.periodicals.datatable.headers.value,
              align: 'left',
              sortable: true,
              value: 'value',
              width: '20%'
            },
            {
              text: language.financial.periodicals.datatable.headers.actions,
              align: 'left',
              sortable: false,
              value: 'actions',
              filterable: false,
              width: '15%'
            }
          ],
        ],
        overview_cashflow: [
          {
            text: ' ',
            align: 'left',
            sortable: false,
            value: 'icon',
            width: '5%'
          },
          {
            text: language.financial.cashflow.datatable.headers.date,
            align: 'left',
            sortable: true,
            value: 'datetime',
            width: '15%'
          },
          {
            text: language.financial.cashflow.datatable.headers.title,
            align: 'left',
            sortable: true,
            value: 'title',
            width: '45%'
          },
          {
            text: language.financial.cashflow.datatable.headers.value,
            align: 'left',
            sortable: true,
            value: 'value',
            width: '30%'
          },
          {
            text: language.financial.cashflow.datatable.headers.actions,
            align: 'left',
            sortable: false,
            value: 'actions',
            filterable: false,
            width: '5%'
          }
        ],
        cashflow: [
          {
            text: ' ',
            align: 'left',
            sortable: false,
            value: 'icon',
            width: '3%'
          },
          {
            text: language.financial.cashflow.datatable.headers.datetime,
            align: 'left',
            sortable: true,
            value: 'datetime',
            width: '10%'
          },
          {
            text: language.financial.cashflow.datatable.headers.title,
            align: 'left',
            sortable: true,
            value: 'title',
            width: '42%'
          },
          {
            text: language.financial.cashflow.datatable.headers.value,
            align: 'left',
            sortable: true,
            value: 'value',
            width: '30%'
          },
          {
            text: language.financial.cashflow.datatable.headers.actions,
            align: 'left',
            sortable: false,
            value: 'actions',
            filterable: false,
            width: '15%'
          }
        ],
        periodicals: {
          bills: [
            {
              text: language.financial.periodicals.datatable.headers.id,
              align: 'left',
              sortable: true,
              value: 'id',
              width: '10%'
            },
            {
              text: language.financial.periodicals.datatable.headers.period,
              align: 'left',
              sortable: true,
              value: 'period',
              width: '15%'
            },
            {
              text: language.financial.periodicals.datatable.headers.date,
              align: 'left',
              sortable: true,
              value: 'date',
              width: '10%'
            },
            {
              text: language.financial.periodicals.datatable.headers.title,
              align: 'left',
              sortable: true,
              value: 'title',
              width: '15%'
            },
            {
              text: language.financial.periodicals.datatable.headers.value,
              align: 'left',
              sortable: true,
              value: 'value',
              width: '15%'
            },
            {
              text: language.financial.periodicals.datatable.headers.last_paid,
              align: 'left',
              sortable: true,
              value: 'last_paid',
              width: '13%'
            },
            {
              text: language.financial.periodicals.datatable.headers.next_due,
              align: 'left',
              sortable: true,
              value: 'next_due',
              width: '13%'
            },
            {
              text: language.financial.periodicals.datatable.headers.actions,
              align: 'left',
              sortable: false,
              value: 'actions',
              filterable: false,
              width: '14%'
            }
          ],
          salary: [
            {
              text: language.financial.periodicals.datatable.headers.id,
              align: 'left',
              sortable: true,
              value: 'id',
              width: '7%'
            },
            {
              text: language.financial.periodicals.datatable.headers.employee,
              align: 'left',
              sortable: true,
              value: 'employee',
              width: '15%'
            },
            {
              text: language.financial.periodicals.datatable.headers.period,
              align: 'left',
              sortable: true,
              value: 'period',
              width: '10%'
            },
            {
              text: language.financial.periodicals.datatable.headers.date,
              align: 'left',
              sortable: true,
              value: 'date',
              width: '10%'
            },
            {
              text: language.financial.periodicals.datatable.headers.title,
              align: 'left',
              sortable: true,
              value: 'title',
              width: '13%'
            },
            {
              text: language.financial.periodicals.datatable.headers.value,
              align: 'left',
              sortable: true,
              value: 'value',
              width: '10%'
            },
            {
              text: language.financial.periodicals.datatable.headers.last_paid,
              align: 'left',
              sortable: true,
              value: 'last_paid',
              width: '13%'
            },
            {
              text: language.financial.periodicals.datatable.headers.next_due,
              align: 'left',
              sortable: true,
              value: 'next_due',
              width: '13%'
            },
            {
              text: language.financial.periodicals.datatable.headers.actions,
              align: 'left',
              sortable: false,
              value: 'actions',
              filterable: false,
              width: '14%'
            }
          ]
        },
        bills: [
          {
            text: '#ID',
            align: 'left',
            sortable: false,
            value: 'id',
            width: '5%'
          },
          {
            text: language.financial.bills.datatable.headers.datetime,
            align: 'left',
            sortable: true,
            value: 'datetime',
            width: '10%'
          },
          {
            text: language.financial.bills.datatable.headers.title,
            align: 'left',
            sortable: true,
            value: 'title',
            width: '25%'
          },
          {
            text: language.financial.bills.datatable.headers.bills,
            align: 'left',
            sortable: true,
            value: 'bills',
            width: '30%'
          },
          {
            text: language.financial.bills.datatable.headers.value,
            align: 'left',
            sortable: true,
            value: 'value',
            width: '15%'
          },
          {
            text: language.financial.bills.datatable.headers.actions,
            align: 'left',
            sortable: false,
            value: 'actions',
            filterable: false,
            width: '15%'
          }
        ],
        salary: [
          {
            text: '#ID',
            align: 'left',
            sortable: false,
            value: 'id',
            width: '5%'
          },
          {
            text: language.financial.salary.datatable.headers.datetime,
            align: 'left',
            sortable: true,
            value: 'datetime',
            width: '10%'
          },
          {
            text: language.financial.salary.datatable.headers.title,
            align: 'left',
            sortable: true,
            value: 'title',
            width: '25%'
          },
          {
            text: language.financial.salary.datatable.headers.salary,
            align: 'left',
            sortable: true,
            value: 'salary',
            width: '30%'
          },
          {
            text: language.financial.salary.datatable.headers.value,
            align: 'left',
            sortable: true,
            value: 'value',
            width: '15%'
          },
          {
            text: language.financial.salary.datatable.headers.actions,
            align: 'left',
            sortable: false,
            value: 'actions',
            filterable: false,
            width: '15%'
          }
        ]
      },
      users: [
        {
          text: language.users.datatable.headers.id,
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: language.users.datatable.headers.name,
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: language.users.datatable.headers.login,
          align: 'left',
          sortable: true,
          value: 'login'
        },
        { text: language.users.datatable.headers.function, value: 'function' },
        { text: language.users.datatable.headers.category, value: 'category' },
        {
          text: language.users.datatable.headers.action,
          align: 'left',
          sortable: false,
          value: 'action',
          filterable: false
        }
      ],
      permissions: [
        {
          text: language.permissions.datatable.headers.id,
          align: 'left',
          sortable: true,
          value: 'id',
          width: '15%'
        },
        { text: language.permissions.datatable.headers.title, value: 'title' },
        { text: language.permissions.datatable.headers.action, value: 'action', sortable: false, filterable: false }
      ]
    }
  },
  getters: {
    getTableHeaders (state) {
      return state.headers
    }
  }
}
